// extracted by mini-css-extract-plugin
export default {"table-container":"AppTable_table-container__kY3Fy","table":"AppTable_table__DxI9n","header":"AppTable_header__Z0A3y"};